// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Block$OrcaPaymentPage from "./Block.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentElementShimmer$OrcaPaymentPage from "./PaymentElementShimmer.bs.js";

function PaymentShimmer(props) {
  var __showInBlock = props.showInBlock;
  var showInBlock = __showInBlock !== undefined ? __showInBlock : true;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var bottomElement = React.createElement(PaymentElementShimmer$OrcaPaymentPage.Shimmer.make, {
        children: React.createElement("div", {
              className: "w-full h-2 animate-pulse",
              style: {
                backgroundColor: match.themeObj.colorPrimary,
                opacity: "10%"
              }
            }),
        classname: "opacity-50"
      });
  if (showInBlock) {
    return React.createElement(Block$OrcaPaymentPage.make, {
                bottomElement: Caml_option.some(bottomElement)
              });
  } else {
    return bottomElement;
  }
}

var make = PaymentShimmer;

export {
  make ,
}
/* react Not a pure module */
